import {
  GetRequest,
  GetRequestCached,
  GetRequestCached2,
  GetRequestCachedV3,
  GetRequestNoHeader,
  PostRequest,
  PostRequestCachedV3,
  PostRequestV2,
} from '../../components/common/api'
import * as types from '../action_types'
import * as iid from '../../components/common/bookingElementId'
import { API_CACHE_DURATION, STA_TWO_WHEELER_C_ID, urls } from '../../components/common/constants'
import { isEmpty, isNull, isWithinFourHours, redirectToLogin } from '../../components/common/helper'
import { insertDispatchResult } from '../cargoDispatch/dispatch_actions'
import { TicketFormatStructure } from '../../components/content/Reports/GoodBalance/constants'
import { STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { cargoFOCSMSOtpDetails } from '../../components/common/jotaiState/commonStateAtoms'
//import { handleFocusOnclose } from '../../components/content/AdminUpdate/index'
export function updateLoader(data) {
  return {
    type: types.LOADER,
    data,
  }
}

export const updateModal = (data, modalType) => {
  return {
    type: types.MODAL,
    data,
    modalType,
  }
}

export const updateSelectedActivity = (data) => {
  return {
    type: types.SELECTED_ACTIVITY,
    data,
  }
}

export const resetActivityData = (data) => ({
  type: types.RESET_ACTIVITY_DATA,
  data,
})

export const updateSelectedLrNumber = (data) => {
  return {
    type: types.SELECTED_LR_NUMBER,
    data,
  }
}

export const updateSendCityList = (data) => ({
  type: types.STRT_CITY_LIST,
  data,
})

export const updateDestCityList = (data) => ({
  type: types.DEST_CITY_LIST,
  data,
})

export const updateCityList = (data) => ({
  type: types.CITY_LIST,
  data,
})

export const updateRoleRights = (data) => ({
  type: types.ROLE_RIGHTS,
  data,
})

export const updateCompanySettings = (data) => ({
  type: types.COMPANY_SETTINGS,
  data,
})

export const updateCompanyTax = (data) => ({
  type: types.COMPANY_TAX,
  data,
})

export const setSearchLrData = (data) => ({
  type: types.SEARCH_LR_Data,
  data,
})

export const setModifyData = (data, data1) => ({
  type: types.Modify_Data,
  data,
  data1,
})
export const setWayBillExemptedReason = (data) => ({
  type: types.EWAY_BILL_EXMPTED,
  data,
})
export const setLrDetailsList = (data) => ({ type: types.lrDetails_data, data })
//for admin update modify
export function addNewRowModify() {
  return {
    type: types.ADD_NEW_MODIFY_ROW,
  }
}

export function RemoveRowModify(index) {
  return {
    type: types.REMOVE_MODIFY_ROW,
    index,
  }
}

export const setRechargeList = (data) => ({
  type: types.Recharge_List,
  data,
})
export const setRechargePartyList = (data) => ({
  type: types.Recharge_Party_List,
  data,
})
export const setRechargePaymentList = (data) => ({
  type: types.Recharge_Payment_List,
  data,
})

export const setServerDateTime = (data) => ({
  type: types.Server_Date_Time,
  data,
})
export const updatePaymentType = (data) => ({
  type: types.SEL_PAYMENT_TYPES,
  data,
})

export const updateSearchBy = (data) => ({
  type: types.SEL_SEARCH_BY,
  data,
})
export const updatePricingInquiry = (data) => ({
  type: types.PRICING_INQUIRY,
  data,
})

export const updateBrnchList = (data, type = 0) => ({
  type: type == 1 ? types.STRT_BRANCH_LIST : type == 2 ? types.DEST_BRANCH_LIST : types.BRANCH_LIST,
  data,
})
export const setBranchListForAdminUpdate = (data) => ({
  type: types.ADMIN_BRANCH_LIST,
  data,
})

export const updateBookingType = (data) => ({
  type: types.BOOKING_TYPE,
  data,
})
export const updateOtpDetail = (data) => ({
  type: types.OTP_Detail,
  data,
})
export const updateParty = (data, isRcv) => ({
  type: types.PARTY,
  data,
  isRcv,
})

export const updatePartyList = (data, isRcv) => ({
  type: types.PARTY_LIST,
  data,
  isRcv,
})

export const updateConsignmentTypes = (data) => ({
  type: types.CONSIGNMENT_TYPES,
  data,
})

export const updateMethodOfPackingTypes = (data) => ({
  type: types.METHOD_OF_PACKING_TYPES,
  data,
})

export const updateConsignmentType = (data) => ({
  type: types.CONSIGNMENT_TYPE,
  data,
})

export const updateMethodOfPackingType = (data) => ({
  type: types.METHOD_OF_PACKING_TYPE,
  data,
})

export const updateStrtCity = (data) => {
  return {
    type: types.STRT_CITY,
    data,
  }
}

export const updateStrtBrnch = (data) => {
  return {
    type: types.STRT_BRNCH,
    data,
  }
}

export const updateDestCity = (data) => {
  return {
    type: types.DEST_CITY,
    data,
  }
}

export const updateDestBrnch = (data) => {
  return {
    type: types.DEST_BRNCH,
    data,
  }
}

export const updateIDProof = (data) => {
  return {
    type: types.GET_ID_PROOF,
    data,
  }
}

export const getOtp = (data) => {
  return {
    type: types.OTP_REQ,
    data,
  }
}
export const Delivery = (data) => {
  return {
    type: types.GET_POST_DELIVERY,
    data,
  }
}

export const CencelDelivery = (data) => {
  return {
    type: types.CANCEL_DELIVERY,
    data,
  }
}

export const printDelivery = (data, isReprint) => {
  return {
    type: types.GET_PRINT_DELIVERY,
    data,
    isReprint,
  }
}
export const allFormatList = (data) => {
  return {
    type: types.ALL_PRINT_FORMAT_LIST,
    data,
  }
}
export const selectedFormatDetail = (data) => {
  return {
    type: types.SELECTED_FORMAT_DETAIL,
    data,
  }
}
export const ticketFormat = (data, printType, isReprint = false) => {
  return {
    type: types.GET_TICKET_FORMAT,
    data,
    printType,
    isReprint,
  }
}

export const setLoginDataToStore = (data, data1) => {
  return {
    type: types.LOGIN,
    data,
    data1,
  }
}

export const setBookedPnrData = (data) => {
  return {
    type: types.BOOKED_PNR_DATA,
    data,
  }
}
export const setFocApproverList = (data) => {
  return {
    type: types.FOC_APPROV_LIST,
    data,
  }
}
export const setBranchCreditLimit = (data) => {
  return {
    type: types.BRANCH_CREDIT_LIMIT,
    data,
  }
}
export const setDestBranchCreditLimit = (data) => {
  return {
    type: types.DEST_BRANCH_CREDIT_LIMIT,
    data,
  }
}
export const setLastLr = (data) => {
  return {
    type: types.LAST_LR,
    data,
  }
}
export const setEWBAuthDetails = (data) => {
  return {
    type: types.EWB_AUTH_DETAILS,
    data,
  }
}
export const addEWBDetails = (data) => {
  return {
    type: types.ADD_EWB_DETAILS,
    data,
  }
}
export const removeEWBDetails = (data) => {
  return {
    type: types.REMOVE_EWB_DETAILS,
    data,
  }
}
export const resetEWBDetails = () => {
  return {
    type: types.RESET_EWB_DETAILS,
  }
}
export const currentAddress = (data) => {
  return {
    type: types.CURRENT_ADDRESS,
    data,
  }
}
export const gmapApikeyAction = (data) => {
  return {
    type: types.GMAP_KEY,
    data,
  }
}
export const lrStatus = (data) => {
  return {
    type: types.LR_STATUS,
    data,
  }
}
export const lrStatusCancelTransaction = (data) => {
  return {
    type: types.LR_STATUS_Cancel_Trasaction,
    data,
  }
}
export const updateBranchConfig = (data, data1) => {
  return {
    type: types.BRANCH_CONFIGURATION,
    data,
    data1,
  }
}
//for delivery color behalf of payment type
export const DeliveryBookingTypeColor = (data) => ({
  type: types.DELIVERY_BOOKINGTYPE_ID,
  data,
})

//All action of Branch Transfer Start
export const trByVehicle = (data) => {
  return {
    type: types.VEHICLE_LIST,
    data,
  }
}

export const driverInfo = (data) => {
  return {
    type: types.DRIVER_INFO_LIST,
    data,
  }
}

export const updateCitiesBrnchList = (data, type = 0) => ({
  type: type == 1 ? types.STRT_BRANCH_LIST : type == 2 ? types.DEST_CITIES_BRANCH_LIST : types.BRANCH_LIST,
  data,
})

export const UpdateAllState = (data) => ({
  type: types.ALL_STATES,
  data,
})

export const UpdateListData = (data) => ({
  type: types.LIST_DATA,
  data,
})
export const UpdateBranchTransfer = (data) => ({
  type: types.BRANCH_TRANSFER,
  data,
})
export const UpdateCancelTransferList = (data) => ({
  type: types.BRANCH_TRANSFER_CANCEL_LIST,
  data,
})
export const UpdateCancelTransfer = (data) => ({
  type: types.BRANCH_TRANSFER_CANCEL,
  data,
})
export const UpdatePrintMemo = (data) => ({
  type: types.PRINT_MEMO,
  data,
})
export const UpdateCheckingReport = (data) => ({
  type: types.CHECKING_REPORT,
  data,
})
export const UpdateUpdateTransfer = (data) => ({
  type: types.UPDATE_TRANSFER,
  data,
})
export const UpdateGetChallanNumber = (data) => ({
  type: types.UPDATE_GET_CHALLAN_NUMBER,
  data,
})
export const updateModifyData = (param, key, data, cnsgnmntTypes = {}) => ({
  type: types.MODIFY_SECTION_DATA,
  param,
  key,
  data,
  cnsgnmntTypes,
})
export const updateModifyRowData = (param, data) => ({
  type: types.Modify_ROW,
  param,
  data,
})
//All action of Branch Transfer End
//for dashboard data
export const UpdateDispatchDashboard = (data) => ({
  type: types.DASHBOARD_DISPATCH_DETAILS,
  data,
})
export const UpdateBranchReceiveDashboard = (data) => ({
  type: types.DASHBOARD_BRANCHRECEIVE_DETAILS,
  data,
})
export const UpdateReceiveDashboard = (data) => ({
  type: types.DASHBOARD_RECEIVE_DETAILS,
  data,
})
//end dashboard
export const UpdateGSTNValidation = (data) => ({
  type: types.VALIDATE_GSTN,
  data,
})
export const updateParentCompanyData = (data, isBooking) => ({
  type: types.PARENT_COMPANY_DATA,
  data,
  isBooking,
})
export const updateBkgPermission = (data) => ({ type: types.BOOKING_PERMISSION_DATA, data })
export const updateGSTConfig = (data) => ({
  type: types.GST_CONFIG,
  data,
})
export const updateDistance = (data) => ({ type: types.CITY_DISTANCE, data })

export const UpdateMOFPayment = (data) => ({
  type: types.METHO_OF_PAYMENT,
  data,
})
export const UpdateBankAccountDetail = (data) => ({
  type: types.BANK_ACCOUNT_DETAILS,
  data,
})
export const UpdateSetApiKey = (data) => ({
  type: types.SET_GOOGLE_APIKEY,
  data,
})
export const updateCompCityList = (data) => ({
  type: types.COMP_CITY_LIST,
  data,
})
export const updateUserList = (data) => {
  return {
    type: types.USER_LIST,
    data,
  }
}
export const updateWeightChrg = (data, index) => {
  return {
    type: types.WEIGHT_CHARGE,
    data,
    index
  }
}

export const updateGetPolicy = (data) => {
  return {
    type: types.GET_POLICY_RIGHTS,
    data,
  }
}

export const updateCancelBooking = (data) => ({ type: types.BOOKING_REFUND, data })

// for Delivery Memo
export const setDeliveryMemoList = (data) => ({
  type: types.DELIVERY_MEMO_LIST,
  data,
})

export const setRollRightsData = (data) => ({
  type: types.SET_ROLL_RIGHTS,
  data,
})

export const updateCityBranchMatrix = (data, cityID) => ({
  type: types.CITY_BRANCH_MATRIX,
  data, cityID
})

export const updateFtlBkngCityList = (data, cityID) => ({
  type: types.FTL_CITY_LIST,
  data, cityID
})


export const getGstConfig = (data) => (dispatch) => {
  GetRequest(urls.gstConfig, data)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateGSTConfig(res.Data.Table[0]))
      } else {
        dispatch(updateGSTConfig({}))
      }
    })
    .catch((err) => { })
}
export const updatePassword =(data)=> (dispatch)=>{
  return new Promise((resolve, reject) => {
    PostRequest(urls.ResetPassword, data)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export const fetchLogin = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.login, { ...data })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.Status === 'true') {
        if ([2, 3].includes(res.Data.BranchTypeID)) {
          dispatch(setLoginDataToStore(res.Data, res.Data2.Table1))
          sessionStorage.setItem('token', JSON.stringify(res.Data))
          sessionStorage.setItem('token1', JSON.stringify(res.Data2.Table1))
          if(data?.GUID){
            sessionStorage.setItem('DeviceID', JSON.stringify(data.GUID))
          }
        } else {
          dispatch(updateAlertError({ show: true, msg: 'Cargo Booking Not Enabled For Your Branch. Please Contact Your Admin.', nextId: '', close: redirectToLogin }))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: 'Login Failed', nextId: '', close: redirectToLogin }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getCargoCompanySetting = (loginData) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getCargoSetting, {
    intCompanyID: loginData.intCompanyID,
    intBranchID: loginData.intBranchID,
    intUserID: loginData.intUserID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateCompanySettings(res.Data))
      } else {
        dispatch(updateCompanySettings([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateCompanySettings([]))
    })
}

export const getOwnParentCompany =
  (data, isBooking = false) =>
    (dispatch) => {
      const { intMode: mode } = data
      dispatch(updateLoader(true))
      GetRequestCachedV3(urls.getOwnParentCompany, data,true,API_CACHE_DURATION)
        .then((res) => {
          dispatch(updateLoader(false))
          dispatch(updateParentCompanyData({ [mode]: res.Data.Table[0] }, isBooking))
        })
        .catch((err) => {
          dispatch(updateLoader(false))
        })
    }
export const cargoGetBranchBkgPermission = (data) => (dispatch) => {
  GetRequest(urls.cargoGetBranchBkgPermission, data)
    .then((res) => {
      if (res.Success === true) {
        dispatch(updateBkgPermission(res.Data))
      } else {
        dispatch(updateBkgPermission({}))
      }
    })
    .catch((err) => { })
}

export const getCargoRoleRightsConfigListAll = (loginData, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  if (!isEmpty(loginData)) {
    GetRequestCachedV3(urls.getRoleRights, {
      intRoleID: loginData.intRoleID,
      intUserID: loginData.intUserID,
    }, isCache, cacheDuration)
      .then((res) => {
        if (res.status == 'Success') {
          dispatch(updateLoader(false))
          dispatch(updateRoleRights(res.Data))
        } else {
          dispatch(updateLoader(false))
          dispatch(updateRoleRights([]))
        }
      })
      .catch((err) => {
        dispatch(updateLoader(false))
        dispatch(updateRoleRights([]))
      })
  }
}

export const getCityList = (loginData, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getCityList, {
    intUserID: loginData.intUserID,
    intCompanyID: loginData.intCompanyID,
    intStateID: 0,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateCityList(res.Data.Table))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
  // .then((res) => {
  //   dispatch(updateLoader(false))
  //   // console.log(res)
  //   if (res.status === 'Success') {
  //     dispatch(updateCityList(res.Data.Table))
  //   }
  // })
  // .catch((err) => {
  //   dispatch(updateLoader(false))
  // })
  dispatch(updateStrtCity({}))
  dispatch(updateCityList([]))
}
export const getCargoCitiesWithPaymentTypeRights =
  (loginData, IsFromTo = 1) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      GetRequest(urls.getCargoCitiesWithPaymentTypeRights, {
        intCompanyID: loginData.intCompanyID,
        intBranchID: loginData.intBranchID,
        IsFromTo,
        intUserID: loginData.intUserID,
      })
        .then((res) => {
          dispatch(updateLoader(false))
          const cityList = res.status == 'Success' ? res?.Data?.Table || [] : []
          switch (IsFromTo) {
            case 1:
              dispatch(updateSendCityList(cityList))
              break
            case 2:
              dispatch(updateDestCityList(cityList))
              break
            default:
              break
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          switch (IsFromTo) {
            case 1:
              dispatch(updateSendCityList([]))
              break
            case 2:
              dispatch(updateDestCityList([]))
              break
            default:
              break
          }
        })
    }

export const getBranchConfigOrEwbillinfo = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, data, isCache, cacheDuration)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateBranchConfig(res.Data.Table[0], res.Data.Table))
      } else {
        dispatch(updateBranchConfig([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getBranchListForAdminUpdate = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getBranchList, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        const cargoBranches = res.Data.Table.filter((el) => [2, 3].includes(el.BranchTypeID))
        dispatch(setBranchListForAdminUpdate(cargoBranches))
      } else {
        dispatch(setBranchListForAdminUpdate([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setBranchListForAdminUpdate([]))
    })
}
export const getBranchList =
  (loginData, intCityID = 0, type = 0, isCache = false, cacheDuration = 0
  ) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      GetRequestCachedV3(urls.getBranchList, {
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intCityID: type === 0 ? loginData.intBranchCityID : intCityID,
        intBookingBranchID: loginData?.intBranchID || 0,
      }, isCache, cacheDuration)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status == 'Success') {
            const cargoBranches = res.Data.Table.filter((el) => [2, 3].includes(el.BranchTypeID))
            dispatch(updateBrnchList(cargoBranches, type))
          } else {
            dispatch(updateBrnchList([], type))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          dispatch(updateBrnchList([], type))
        })
    }
//pricing Inquiry

export const GetCargoRateInquiryV3 = (data, distance) => (dispatch) => {
  GetRequest(urls.GetCargoRateInquiryV3, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        if (data.intCompanyID === STA_COMPANY_ID && data.intConsignmentID === STA_TWO_WHEELER_C_ID) {
          let rate = 1000
          if (distance > 333) rate = 2000
          dispatch(updatePricingInquiry([{ ...res.Data.Table[0], ExpressRate: rate, NormalRate: rate }]))
        } else {
          dispatch(updatePricingInquiry(res.Data.Table))
        }
      } else {
        dispatch(updatePricingInquiry([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updatePricingInquiry([]))
      // console.log(err);
    })
}

export const getBranchListDispatch =
  (data, type = 0, isCache = false, cacheDuration = 0) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      GetRequestCachedV3(urls.getBranchList, data, isCache, cacheDuration)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status == 'Success') {
            const cargoBranches = res.Data.Table.filter((el) => [2, 3].includes(el.BranchTypeID))
            dispatch(updateBrnchList(cargoBranches, type))
          } else {
            dispatch(updateBrnchList([], type))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          dispatch(updateBrnchList([], type))
        })
    }

export const getIDProofList = (loginData) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getIDProofList, {
    intCompanyID: loginData.intCompanyID,
    intBranchID: loginData.intBranchID,
    intUserID: loginData.intUserID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateIDProof(res.Data))
      } else {
        dispatch(updateIDProof([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateIDProof([]))
    })
}


export const getConsignmentSubTypes = (loginData, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getConsignmentSubTypes, {
    intConsignmentSubTypeID: 0,
    intCompanyID: loginData.intCompanyID,
    intConsignmentTypeID: 0,
    strSubType: '',
    intIsActive: 1,
    intIsDeleted: 0,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateConsignmentTypes(res.Data))
      } else {
        dispatch(updateConsignmentTypes([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateConsignmentTypes([]))
    })
}

export const getMethodOfPacking = (loginData, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMethodOfPacking, {
    intCompanyID: loginData.intCompanyID,
    intUserID: loginData.intUserID,
    intIsActive: 1,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateMethodOfPackingTypes(res.Data?.Table || []))
      } else {
        dispatch(updateMethodOfPackingTypes([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateMethodOfPackingTypes([]))
    })
}

export const getPartyList =
  (data, isRcvr = false, isCache = false, cacheDuration = 0) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      PostRequest(urls.getPartyList, data, isCache, cacheDuration)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status == 'Success') {
            dispatch(updatePartyList(res.Data, isRcvr))
          } else {
            dispatch(updatePartyList([], isRcvr))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          dispatch(updatePartyList([]))
        })
    }

export const focSMSOTP = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  cargoFOCSMSOtpDetails(obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res) {
        dispatch(updateOtpDetail(res))
      } else {
        dispatch(updateOtpDetail([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateOtpDetail([]))
    })
}
export const getTicketData = (data, resetPaymentType) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.bookingsLoad, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        const { Data, ErrMessage = '' } = res
        const { CurrentDate, CurrentTime, JourneyDate } = { ...Data }
        if (ErrMessage) {
          dispatch(updateAlertError({ show: true, msg: res.ErrMessage }))
          resetPaymentType()
        } else if (!isWithinFourHours(CurrentDate, CurrentTime, JourneyDate)) {
          dispatch(updateAlertError({ show: true, msg: 'Self Booking allowed only with in 4 Hours before/after Journy Time' }))
          resetPaymentType()
        } else dispatch(setBookedPnrData(res.Data))
      } else {
        dispatch(setBookedPnrData(''))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setBookedPnrData(''))
    })
}

export const getFocApproversList = (loginData) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.focApproverList, {
    intCompanyID: loginData.intCompanyID,
    intConsignmentSubTypeID: '147',
  })
    .then((res) => {
      dispatch(updateLoader(false))
      const approverlist = res.status == 'Success' ? res?.Data?.Table || [] : []
      if (res.status == 'Success') {
        dispatch(setFocApproverList(approverlist))
      } else {
        dispatch(setFocApproverList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setFocApproverList([]))
    })
}
export const getbranchCreditLimit = (loginData) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.branchCreditLimit, {
    intCompanyID: loginData.intCompanyID,
    intBranchID: loginData.intBranchID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      const branchCreditLimit = res.status == 'Success' ? res?.Data?.Table[0] || [] : []
      if (res.status == 'Success') {
        dispatch(setBranchCreditLimit(branchCreditLimit))
      } else {
        dispatch(setBranchCreditLimit([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setBranchCreditLimit([]))
    })
}
export const getDestBranchCreditLimit = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.branchCreditLimit, {
    intCompanyID: data.intCompanyID,
    intBranchID: data.intBranchID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      const branchCreditLimit = res.status == 'Success' ? res?.Data?.Table[0] || [] : []
      if (res.status == 'Success') {
        dispatch(setDestBranchCreditLimit(branchCreditLimit))
      } else {
        dispatch(setDestBranchCreditLimit([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setDestBranchCreditLimit([]))
    })
}

export const getLastLR = (loginData) => (dispatch) => {
  GetRequest(urls.getLastLR, {
    intCompanyID: loginData.intCompanyID,
    intBranchID: loginData.intBranchID,
    intUserID: loginData.intUserID,
  })
    .then((res) => {
      if (res.status == 'Success') {
        const lastLR = {}
        lastLR['LRNO'] = res.LRNO
        lastLR['FormattedLRNo'] = res.FormattedLRNo
        dispatch(setLastLr(lastLR))
      } else {
        dispatch(setLastLr([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setLastLr([]))
    })
}

export const getEwaybillData = (loginData, strEWBNumber, ewayBillAuthDetails) => (dispatch) => {
  dispatch(updateLoader(true))
  const ewb = ewayBillAuthDetails[0] || {}
  // const strEWBConfig = ewb.ewbUserId + `~` + ewb.EwbPwd + `~` + ewb.EwbUserId + `~` + ewb.EwbPwd + `~` + ewb.EWBTransporterId
  const strEWBConfig = ewb.EWBApiUserId + '~' + ewb.EWBApiPwd + '~' + ewb.EwbUserId + '~' + ewb.EwbPwd + '~' + ewb.EWBTransporterId
  PostRequest(urls.getEWBInfo, {
    // intCompanyID: loginData.intUserID,
    intCompanyID: loginData.intCompanyID,
    strEWBNumber: strEWBNumber,
    intBookingID: 0,
    strEWBConfig: strEWBConfig,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      const ewayBillDetailsList = res.status == 'Success' ? res?.Data?.Table[0] || [] : []
      if (res.status == 'Success') {
        dispatch(addEWBDetails(ewayBillDetailsList))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: iid.ewaybillNoInput }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const removeEWaybill = (EwayBillNo) => (dispatch) => {
  dispatch(removeEWBDetails(EwayBillNo))
}
export const updateAlertError = (data) => {
  return {
    type: types.ALERT,
    data,
  }
}
export const updateAlert = (data) => (dispatch) => {
  dispatch(updateAlertError(data))
}

export const PostDelivery = (data) => (dispatch) => {
  if (data.bookingType === 2 && !data.dblOutstanding) {
    // console.log('topay 0 amount')
    return
  }
  const { dblOutstanding, dblTotalDues, dblHomeDeliveryChg, dblExtraHamali, dblDemurrageChg, dblAddtitionalDeliveryCartage, dblDeliveryGST, dblDeliveryDisc } = data
  const finalAmtSome=+dblTotalDues+ +dblHomeDeliveryChg+ +dblExtraHamali+ +dblDemurrageChg+ +dblAddtitionalDeliveryCartage+ +dblDeliveryGST- +dblDeliveryDisc
  if (+finalAmtSome.toFixed(2) !== +Number(dblOutstanding).toFixed(2)) {
    debugger
    return 
  } 
  dispatch(updateLoader(true))
  PostRequest(urls.deliveryWebInsert, data)
    .then((res) => {
      dispatch(updateLoader(false))

      if (res.status == 'Success') {
        // dispatch(updateLoader(false));

        dispatch(Delivery(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage }))
        dispatch(Delivery(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(Delivery(err))
    })
}
export const cancelBooking = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.cancelBooking, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateCancelBooking(true))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '', close: redirectToLogin }))
      }
    })
    .catch((err) => { })
}

export const cencelDelivery = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(
    // urls.cencelDelivery+`intDeliveryID=1&strLRNO=hii&intCompanyID=1&intBookingID=112&strRemarks=hi &intUserID=1&intIsApp=2`
    urls.cencelDelivery,
    {
      intDeliveryID: 0,
      strLRNO: data.Lrnumber,
      intCompanyID: loginData.intCompanyID,
      intBookingID: data.BookingID,
      strRemarks: data.Remarks,
      intUserID: loginData.intUserID,
      intIsApp: 2,
    }
  )
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(CencelDelivery(res))
      } else {
        dispatch(CencelDelivery(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const luggegePrint =
  (data, isReprint = false) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      PostRequestV2(urls.printDelivery, data)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status == 'Success') {
            const {Data={}}=res
            const {Table=[]}=Data
            dispatch(printDelivery(Table, isReprint))
          } else {
            dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
            dispatch(printDelivery([]))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
        })
    }

export const ticketFormatAll =
  (props, isReprint = false) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      const printType = props.printType ? props.printType : 'ticket'
      PostRequestV2(urls.cargoTicketFormat, {
        intTicketFormatID: props?.TicketFormatID || 0,
        intCompanyID: 0,
        strFormatType: props?.FormatType || 'B',
        intIsDeleted: props?.isDeleted || 0,
      })
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status == 'Success') {
            dispatch(ticketFormat(res.Data, printType, isReprint))
          } else {
            dispatch(ticketFormat([]))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
        })
    }
export const getPrintFormatList = (CompanyID=0) => (dispatch) => {
  GetRequestCached2(urls.StandardPrintFormatList)
    .then((res) => {
      const {Data={}}=res||{};
      const {Table=[]}=Data;
      // const list = Table.filter((item) => {
      //   if (CompanyID === STA_COMPANY_ID) {
      //     return true;
      //   }
      //   return item.FormatID !== 6;
      // });
      dispatch(allFormatList(Table))
    })
    .catch((e) => {
      console.log(e)
    })
}
export const getCurrentFormatDetails = (data) => (dispatch) => {
  GetRequest(urls.StandardPrintFormatDetails, data)
    .then((res) => {
      if (res.status === 'Success') {
        if (res.Data.Table.length) dispatch(selectedFormatDetail(res.Data.Table?.[0]))
        else dispatch(selectedFormatDetail(TicketFormatStructure))
      } else {
        dispatch(updateAlertError({ show: true, msg: 'No Data Found!', nextId: '' }))
      }
    })
    .catch((e) => {
      console.log(e)
    })
}
export const saveWaybillDetail = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.CompanyStandardPrintFormatDetailsSave, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((e) => console.log(e))
}
export const getVehicleListV2 = (data) => (dispatch) => {
  const date = new Date()
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  dispatch(updateLoader(true))
  PostRequest(urls.getVehilceList, {
    dtJdate: `${year}-${month}-${day}`,
    intMode: 400,
    ...data,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(trByVehicle(res.Data))
      } else {
        dispatch(trByVehicle([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//All action of Branch Transfer Start
export const getVehicleList = (loginData, isCache = false, cacheDuration = 0) => (dispatch) => {
  // console.log(loginData)
  const date = new Date()
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getVehilceList, {
    intCompanyID: loginData.intCompanyID,
    intFromCityID: 298,
    intToCityID: 298,
    dtJdate: `${year}-${month}-${day}`,
    intMode: 1,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(trByVehicle(res.Data))
      } else {
        dispatch(trByVehicle([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getAllStates = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getBranchList, {
    intUserID: loginData.intUserID,
    intCompanyID: loginData.intCompanyID,
    intCityID: 0,
    intBookingBranchID: 0,
  }, true, API_CACHE_DURATION)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(UpdateAllState(res.Data))
      } else {
        dispatch(UpdateAllState([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getDriverList = (loginData, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getDriverList, {
    intUserID: loginData.intUserID,
    intDriverConductorID: 0,
    intCompanyID: loginData.intCompanyID,
    intBusID: 0,
    intIsDriver: 1,
    intStateID: 0,
    intCityID: 0,
    intIsActive: 1,
    CrewTypeID: 1,
  }, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(driverInfo(res.Data))
      } else {
        dispatch(driverInfo([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getCitiesBranchList =
  (loginData, intCityID = 0, type = 0) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      GetRequestCachedV3(urls.getBranchList, {
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intCityID: type == 0 ? loginData.intBranchCityID : intCityID,
        intBookingBranchID: -1,
      }, true, API_CACHE_DURATION)
        .then((res) => {
          dispatch(updateLoader(false))

          if (res.status == 'Success') {
            dispatch(updateCitiesBrnchList(res.Data.Table || [], type))
          } else {
            dispatch(updateCitiesBrnchList([], type))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          dispatch(updateCitiesBrnchList([], type))
        })
    }

export const getListData = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getListData, {
    LRNO: '',
    CurrentCityID: data.CurrentCityID,
    CurrentBranchID: data.CurrentBranchID,
    UserID: loginData.intUserID,
    BranchID: data.BranchID,
    CityID: data.CityID,
    ConsignmentSubTypeID: data.ConsignmentSubTypeID,
    IsBranchTransfer: data.IsBranchTransfer,
    PaymentTypeID: data.PaymentTypeID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.Success == true) {
        dispatch(UpdateListData(res.Data))
      } else {
        dispatch(UpdateListData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getBranchTransfer = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getBranchTransfer, {
    intBranchTransferID: data.intBranchTransferID,
    intFromCityID: data.intFromCityID,
    intToCityID: data.intToCityID,
    intFromBranchID: data.intFromBranchID,
    intToBranchID: data.intToBranchID,
    intCompanyID: loginData.intCompanyID,
    strVehicleType: data.strVehicleType,
    strVehicleNo: data.strVehicleNo,
    strTransferReason: data.strTransferReason,
    strRemarks: data.strRemarks,
    intUserID: loginData.intUserID,
    blnDeliveryTransfer: data.blnDeliveryTransfer,
    intVehicleID: data.intVehicleID,
    strBookingIDs: data.strBookingIDs,
    strLRNos: data.strLRNos,
    strShortQtys: data.strShortQtys,
    strDamageQtys: data.strDamageQtys,
    intDriverID: data.intDriverID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == true) {
        dispatch(UpdateBranchTransfer(res))
      } else {
        dispatch(UpdateBranchTransfer(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}


export const getBranchTransferV2 = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getBranchTransferV2, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == true) {
        dispatch(UpdateBranchTransfer(res))
      } else {
        dispatch(UpdateBranchTransfer(res))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}


export const getCancelTransferList = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCancelTransferList, {
    FromCityID: data.FromCityID,
    FromBranchID: data.FromBranchID,
    ToCityID: data.ToCityID,
    FromDate: data.FromDate,
    ToDate: data.ToDate,
    DestinationCityID: data.DestinationCityID,
    SourceCityID: data.SourceCityID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == true) {
        dispatch(UpdateCancelTransferList(res.Data))
      } else {
        dispatch(UpdateCancelTransferList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getCancelTransfer = (loginData, data, onClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getCancelTransfer, {
    strBookingIDs: data.strBookingIDs,
    strBranchTransferIDS: data.strBranchTransferIDS,
    intIsShortReceipt: 0,
    intUserID: loginData.intUserID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == true) {
        dispatch(UpdateCancelTransfer(res))
        // dispatch(updateAlertError({ show: true, msg: 'Cancelled Successfully!', success: true, close: onClosePopup }))
      } else {
        dispatch(UpdateCancelTransfer([]))
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(UpdateCancelTransfer([]))
      dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
    })
}

export const getPrintMemo = (loginData, data,updateModal) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getPrintMemo, {
    intFromCityID: data.intFromCityID,
    intFromBranchID: data.intFromBranchID,
    intToCityID: 0,
    intToBranchID: 0,
    intCompanyID: loginData.intCompanyID,
    DateFrom: data.date,
    DateTo: data.date,
    intMode: 0,
    intBranchTransferID: 0,
    strVehicleNo: data?.vehicleNo || '' ,
    intConsignmentSubTypeID: 0,
    intChallanNo: data.intChallanNo,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(UpdatePrintMemo(res))
      } else {
        dispatch(UpdatePrintMemo([]))
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
        updateModal(false, 'PrintMemo')
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateAlertError({ show: true, msg: err.Message, nextId: '' }))
      updateModal(false, 'PrintMemo')
    })
}

export const getCheckingReport = (loginData, data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCheckingReport, {
    intFromCityID: data.intFromCityID,
    intFromBranchID: data.intFromBranchID,
    strToCityIDs: data.strToCityIDs,
    strToBranchIDs: data.strToBranchIDs,
    intCompanyID: loginData.intCompanyID,
    isDtWise: data.isDtWise,
    isbkgDtwise: data.isbkgDtwise,
    fromdt: data.fromdt,
    todt: data.todt,
    UserID: loginData.intUserID,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(UpdateCheckingReport(res))
      } else {
        dispatch(UpdateCheckingReport([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getUpdateTransfer = (data, onClosePopup) => (dispatch) => {
  // console.log(999,data)
  dispatch(updateLoader(true))
  PostRequest(urls.getBranchTransferUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(UpdateUpdateTransfer(res))
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully', nextId: '', success: true, close: onClosePopup }))
      } else {
        dispatch(UpdateUpdateTransfer([]))
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getUpdateGetChallanNum = (data) => (dispatch) => {
  dispatch(UpdateGetChallanNumber(data))
}

export const gMapApiKey =
  (loginData, intApiID = '') =>
    (dispatch) => {
      GetRequest(urls.gMapsApiKey, { intCompanyID: loginData?.intCompanyID || 0, intApiID: intApiID })
        .then((res) => {
          if (res.status === 'Success') {
            const APIKEY = JSON.parse(sessionStorage.getItem('APIKEY'))
            const APIKEYVALID = JSON.parse(sessionStorage.getItem('APIKEYVelid'))
            if (APIKEY !== res?.Data?.Table?.[0]?.APIKey) {
              sessionStorage.setItem('APIKEY', JSON.stringify(res?.Data?.Table?.[0]?.APIKey || '') || '')
              sessionStorage.setItem('APIKEYVelid', JSON.stringify(false) || '')
            }
            if (APIKEYVALID === null || APIKEYVALID === undefined) {
              sessionStorage.setItem('APIKEYVelid', JSON.stringify(false) || '')
            }
            sessionStorage.setItem('DisplayName', JSON.stringify(res?.Data?.Table?.[0]?.DisplayName || '') || '')
            sessionStorage.setItem('DisplayId', JSON.stringify(res?.Data?.Table?.[0]?.DisplayID || '') || '')
            dispatch(gmapApikeyAction(res.Data.Table[0]))
          } else {
            dispatch(gmapApikeyAction(res.Data.Table[0]))
          }
        })
        .catch((err) => {
          // console.log(err)
        })
    }
export const getAddresWithLatLong = (latlong) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCached(urls.gMapApi, {
    latlng: latlong,
    result_type: 'street_address',
    key: 'AIzaSyCmZN3BtNzAYBF7pG0PF1ZhVi-0Os_njrg',
  })
    .then((res) => {
      dispatch(updateLoader(false))
      dispatch(currentAddress(res))
    })
    .catch((err) => console.log(err))
}

export const getLrStatus = (data) => (dispatch) => {
  GetRequest(urls.cargoLrStatus, data)
    .then((res) => {
      dispatch(lrStatus(res))
    })
    .catch((err) => {
    })
}
//getLrStatus for cancel transaction in admin update
export const getLrStatusForCancelTransaction = (loginData, BookingID) => (dispatch) => {
  const data = {
    CompanyID: loginData?.intCompanyID,
    BranchID: loginData.intBranchID,
    BookingID: BookingID,
  }
  GetRequest(urls.LrStatusForCancelTransaction, data)
    .then((res) => {
      dispatch(lrStatusCancelTransaction(res))
    })
    .catch((err) => {
      // console.log(err)
    })
}
export const ResetGlobalState = (loginData, data) => (dispatch) => {
  dispatch(UpdatePrintMemo([]))
  dispatch(UpdateBranchTransfer([]))
  dispatch(UpdateCancelTransfer([]))
  dispatch(Delivery([]))
  dispatch(CencelDelivery([]))
  dispatch(UpdateUpdateTransfer([]))
  dispatch(ticketFormat([]))
  dispatch(printDelivery([]))
  dispatch(insertDispatchResult([]))
}

//All action of Branch Transfer End

//Changes
export const getCargoCommonLRData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getCargoCommonLRData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status) {
        dispatch(setSearchLrData(res?.Data?.Table))
      } else {
        dispatch(setSearchLrData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setSearchLrData([]))
    })
}

export const PartyRechargesListAllRequest = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.PartyRechargesListAllRequest, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status) {
        dispatch(setRechargePartyList(res?.Data?.Table))
        if (res?.Data?.Table?.length == 0) {
          dispatch(updateAlertError({ show: true, msg: 'No Data Found!', nextId: '' }))
        }
      } else {
        dispatch(setRechargePartyList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setRechargePartyList([]))
    })
}
export const GetBranchRechargesListAll = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.GetBranchRechargesListAll, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status) {
        dispatch(setRechargeList(res?.Data?.Table))
        if (res?.Data?.Table?.length == 0) {
          dispatch(updateAlertError({ show: true, msg: 'No Data Found!', nextId: '' }))
        }
      } else {
        dispatch(setRechargeList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setRechargeList([]))
    })
}
export const GetRechargePaymentModesListAll = () => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.GetRechargePaymentModesListAll)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status) {
        dispatch(setRechargePaymentList(res?.Data?.Table))
        if (res?.Data?.Table?.length == 0) {
          dispatch(updateAlertError({ show: true, msg: 'No Data Found!', nextId: '' }))
        }
      } else {
        dispatch(setRechargePaymentList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(setRechargePaymentList([]))
    })
}

export const GetPartyRechargeEditRequest = (data, setRefresh) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.GetPartyRechargeEditRequest, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        setRefresh(true)
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const GetBranchRechargeEditRequest = (data, setRefresh) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.GetBranchRechargeEditRequest, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        setRefresh(true)
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const PartyRechargesReject = (data, setRefresh,setMsg,setIsSuccessReject,party) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.PartyRechargesRejectRequest, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        setRefresh(true)
        setMsg(`${party} Recharge Transaction Reject`)
        setIsSuccessReject(true)
        // dispatch(updateAlertError({ show: true, msg: 'Recharge Rejected!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const BranchRechargesReject = (data, setRefresh) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.BranchRechargesReject, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        setRefresh(true)
        dispatch(updateAlertError({ show: true, msg: 'Recharge Rejected!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const PartyRechargesAccept = (data, setRefresh,setMsg,setIsSuccessPop,party) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.PartyRechargeConfirmRequest, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        setRefresh(true)
        setMsg(`${party} Recharge Transaction Accepted`)
        setIsSuccessPop(true)
        // dispatch(updateAlertError({ show: true, msg: 'Recharge Accepted!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const BranchRechargesAccept = (data, setRefresh) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.BranchRechargesInsertConfirm, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        setRefresh(true)
        dispatch(updateAlertError({ show: true, msg: 'Recharge Accepted!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const SaveDebitCreditNote = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.SetCargoDebitCreditNote, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Saved Successfully!', nextId: '', success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//GET /api/GetLRForModifyUpdate
export const GetLRForModifyUpdate = (obj, props) => (dispatch) => {
  const { data } = {
    ...props,
  }
  const { common } = data
  const { cnsgnmntTypes } = { ...common }
  dispatch(updateLoader(true))
  GetRequest(urls.GetLRForModifyUpdate, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status) {
        let temp = res?.Data?.Table
        const updatedModifyData = temp.map((data) => {
          const cnsgnmntData = cnsgnmntTypes.find(({ ConsignmentSubTypeID }) => ConsignmentSubTypeID == data.ConsignmentSubTypeID)
          return {
            ...data,
            slctdCnsgnmntType: cnsgnmntData,
            unitType: 'MM',
            wt_vlm_ht: '0',
            wt_vlm_len: '0',
            wt_vlm_wid: '0',
          }
        })
        dispatch(setModifyData(updatedModifyData, res?.Data?.Table1))
        if (res?.Data?.Table?.length == 0) {
          dispatch(updateAlertError({ show: true, msg: 'No Data Found!', nextId: '' }))
        }
      } else {
        dispatch(setModifyData([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getLrDetailsWIthBookingID =
  (data, currentList = {}) =>
    (dispatch) => {
      const { BookingID } = data
      dispatch(updateLoader(true))
      GetRequestCached2(urls.GetLRForModifyUpdate, data)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res?.Data?.Table?.length) {
            if (!currentList.hasOwnProperty(BookingID)) {
              dispatch(setLrDetailsList({ ...currentList, [BookingID]: res?.Data }))
            }
          } else {
            dispatch(updateAlertError({ show: true, msg: 'No Data Found For Selected LR', nextId: '' }))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
        })
    }
//LrRollback
export const LRRollBackUpdate = (data, setOnClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.LRRollBackUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Roll Back Successfully', nextId: '', success: true, close: setOnClosePopup }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//Mark As Lost Api
export const MarkAsLost = (data, setOnClosePopup, key) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.MarkAsLost, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (key === 'Success') {
          dispatch(updateAlertError({ show: true, msg: 'Mark As Lost Successfully', nextId: '', success: true, close: setOnClosePopup }))
        } else {
          dispatch(updateAlertError({ show: true, msg: 'Mark As Lost Cancelled Successfully', nextId: '', success: true, close: setOnClosePopup }))
        }
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//SenderReceiverDetailChange
export const SenderReceiverDetailChange = (data, setOnClosePopup, IsAdmin, updateModal, updateData, sendOTP) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.SenderReceiverDetailChange, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        updateModal()
        updateData()
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully!', nextId: '', close: setOnClosePopup, success: true }))
      } else {
        if (data.CompanyID === STA_COMPANY_ID && IsAdmin && res.Message === 'Destination Branch change is allowed by Admin only.') {
          sendOTP('Destination Edit')
        } else {
          dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
          updateModal()
          updateData()
        }
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//Consignment Booking Charges Update

export const ConsignmentBookingChargesUpdate = (data, setOnClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.ConsignmentBookingChargesUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully!', nextId: '', success: true, close: setOnClosePopup }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

//Booking Delivery Details Update
export const BookingDeliveryDetailsUpdate = (data, setOnClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.BookingDeliveryDetailsUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully!', nextId: '', success: true, close: setOnClosePopup }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//EwayBill update From Admin update
export const EwayBillUpdate = (data, setOnClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.EwayBillUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully!', nextId: '', success: true, close: setOnClosePopup }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const GetExemptedGoodsList = () => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.GetExemptedGoodsList, {}, true, API_CACHE_DURATION).then((res) => {
    dispatch(updateLoader(false))
    const { Data, ErrMessage, status } = res || {}
    if (status === 'Success') {
      const { Table=[] } = Data
      dispatch(setWayBillExemptedReason(Table))
    } else {
    }
  })
}
//Cancel Receive From admin Upadte
export const CancelReceive = (data, onClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.CancelReceiveUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Cancelled Successfully!', nextId: '', success: true, close: onClosePopup }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//Cancel branch transfer receive
export const CancelBranchTransferReceive = (data, onClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.CancelBranchReceiveUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Cancelled Successfully!', nextId: '', success: true, close: onClosePopup }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//getServerTime
export const getServerTime = () => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getServerTime).then((res) => {
    dispatch(updateLoader(false))
    if (res) dispatch(setServerDateTime(res))
    else dispatch(setServerDateTime(''))
  })
}
//Booking update for cancel trasaction
export const BookingUpdate = (data, onClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.BookingDetailsUpdate, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        // dispatch(UpdateUpdateTransfer(res))
        dispatch(updateAlertError({ show: true, msg: 'Updated Successfully', nextId: '', success: true, close: onClosePopup }))
      } else {
        // dispatch(UpdateUpdateTransfer([]))
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//gstnValidation
export const validateGSTN =
  (data, isRecve = false, navigation = 0) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      GetRequest(urls.validateGSTN, data)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status === 'True' && isNull(res.error))
            dispatch(UpdateGSTNValidation({ data: res.Data[0], isRecve: isRecve, showPopup: true, GSTN: data.GSTN, navigation: navigation }))
          else dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          dispatch(UpdateGSTNValidation({ isRecve: isRecve, showPopup: false, navigation: navigation }))
        })
    }
//For Dashboard Data
export const getDashBoardData = (data, statusCode) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDashBoardDetails, {
    Companyid: data.intCompanyID,
    CurrentCityID: data.intBranchCityID,
    CurrentBranchID: data?.intBranchID,
    StatusCode: statusCode,
  })
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === true) {
        if (statusCode === 'D') {
          dispatch(UpdateDispatchDashboard(res))
        } else if (statusCode === 'BR') {
          dispatch(UpdateBranchReceiveDashboard(res))
        } else if (statusCode === 'R') {
          dispatch(UpdateReceiveDashboard(res))
        } else {
          // console.log("wrong status")
        }
      } else {
        if (statusCode === 'D') {
          dispatch(UpdateDispatchDashboard(res))
        } else if (statusCode === 'BR') {
          dispatch(UpdateBranchReceiveDashboard(res))
        } else if (statusCode === 'R') {
          dispatch(UpdateReceiveDashboard(res))
        } else {
          // console.log("wrong status")
        }
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getCityDistance =
  (data, isCache = false, cacheDuration = 0) =>
    (dispatch) => {
      dispatch(updateLoader(true))
      GetRequestCachedV3(urls.GetCityDistance, data, isCache, cacheDuration)
        .then((res) => {
          dispatch(updateLoader(false))
          if (res.status === 'Success') {
            const { Data: { Table: [{ Distance = 0 } = {}] = [] } = {} } = res || {}
            dispatch(updateDistance(Distance))
          } else {
            dispatch(updateDistance({}))
          }
        })
        .catch((err) => {
          dispatch(updateLoader(false))
          dispatch(updateDistance({}))
        })
    }
// for methos of payment
export const GetMOFPaymentUpdate = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getMOFPayment, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(UpdateMOFPayment(res))
      } else {
        dispatch(UpdateMOFPayment([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(UpdateMOFPayment([]))
    })
}
export const GetBankAccountDetailUpdate = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.bankAccountDetail, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(UpdateBankAccountDetail(res))
      } else {
        dispatch(UpdateBankAccountDetail([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(UpdateBankAccountDetail([]))
    })
}
//SendBranchInquirySMS
export const SendBranchInquirySMS = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestV2(urls.SendBranchInquirySMS, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res === '') {
        // dispatch(UpdateUpdateTransfer(res))
        if(data?.IsSMS===1){
          dispatch(updateAlertError({ show: true, msg: 'SMS Sent Successfully!', nextId: '', success: true }))
        }else if(data?.IsWhatsApp===1){
          dispatch(updateAlertError({ show: true, msg: 'WhatsApp Message Sent Successfully!', nextId: '', success: true }))
        }
      } else {
        // dispatch(UpdateUpdateTransfer([]))
        dispatch(updateAlertError({ show: true, msg: res.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
// action for delivery memo
export const getDeliveryMemo = (memoData) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDeliveryMemoList, memoData)
    .then((res) => {
      if (res.status == 'Success') {
        if (res?.Data?.Table?.length > 0) {
          dispatch(updateLoader(false))
          dispatch(setDeliveryMemoList(res?.Data?.Table))
        } else {
          dispatch(updateLoader(false))
          dispatch(setDeliveryMemoList([]))
          dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: 'memoNext1' }))
        }
      } else {
        dispatch(setDeliveryMemoList([]))
      }
    })
    .catch((err) => {
      dispatch(setDeliveryMemoList([]))
    })
}

//set Google API Key
export const setGApiKeyUpdate = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.setGMapApiKey, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res?.Data?.Table?.length > 0) {
          dispatch(UpdateSetApiKey(res))
        } else {
          dispatch(updateAlertError({ show: true, msg: res?.Message, nextId: '' }))
        }
      } else {
        dispatch(UpdateSetApiKey({}))
        dispatch(updateAlertError({ show: true, msg: res?.Message, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(UpdateSetApiKey({}))
    })
}
//userList
export const getUserList = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  PostRequestCachedV3(urls.getUserList, data, isCache, cacheDuration)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateUserList(res.Data.Table))
      } else {
        dispatch(updateUserList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getBranchListAndCityList = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}


//GS>>getCityList
export const getCompCityList = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  PostRequestCachedV3(urls.getCompCityList, data, isCache, cacheDuration)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateCompCityList(res?.Data))
      } else {
        dispatch(updateCompCityList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
//Weight charge api
export const getWeightChrg = (data, index) => (dispatch) => {
  GetRequest(urls.getWeightChrg, data)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateWeightChrg(res?.Data?.Table, index))
      } else {
        dispatch(updateWeightChrg({}))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getPolicies = (data) => (dispatch) => {
  GetRequestCached2(urls.getPolicyRights, data)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateGetPolicy(res?.Data))
      } else {
        dispatch(updateGetPolicy({}))
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
    })
}

export const getVehicleListV3 = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  PostRequestCachedV3(urls.getVehilceList, data, isCache, cacheDuration)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(trByVehicle(res.Data))
      } else {
        dispatch(trByVehicle([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const userRollRightEditRights = (obj) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getUserRollRightEditRight, obj)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(setRollRightsData(res.Data))
        sessionStorage.setItem('token1', JSON.stringify(res.Data.Table))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
        dispatch(setRollRightsData([]))
      }
    })
    .catch((err) => {
      dispatch(updateAlertError({ show: true, msg: err?.Message, nextId: '' }))
      dispatch(updateLoader(false))
    })
}
export const crossingCityBranchMatrix = (data) => (dispatch) => {
  const { CityID } = data
  dispatch(updateLoader(true))
  GetRequestCached2(urls.BranchListForCrossingMaster, data)
    .then((res) => {
      dispatch(updateLoader(false))
      dispatch(updateCityBranchMatrix(res.Data.Table, CityID))
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
// export const cancelBookingByAdmin = (obj) => (dispatch) => {
//   return new Promise((resolve, reject) => {
//     dispatch(updateLoader(true))
//     PostRequest(urls.cancelBookingByAdmin, obj)
//       .then((res) => {
//         dispatch(updateLoader(false))
//         return resolve(res)
//       })
//       .catch((error) => {
//         dispatch(updateLoader(false))
//         reject(error)
//       })
//   })
// }
export const cancelBookingByAdmin = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.cancelBookingByAdmin, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateCancelBooking(true))
      } else {
        dispatch(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '', close: redirectToLogin }))
      }
    })
    .catch((err) => { })
}
export const getFtlBkngCityList = (data) => (dispatch) => {
  GetRequest(urls.getCityList, data)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateFtlBkngCityList(res?.Data?.Table))
      } else {
        dispatch(updateFtlBkngCityList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
      dispatch(updateFtlBkngCityList([]))
    })
}
export const getFtlBkngBranchList = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getBranchList, obj,true,API_CACHE_DURATION)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const GetBookingRatesData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.GetBookingRates, obj,true,API_CACHE_DURATION)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBookingInfo = (obj) => () => {
  return new Promise((resolve, reject) => {
    GetRequest(urls.getBookingInfo, obj)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getPartyBookingInfo = (obj) => () => {
  return new Promise((resolve, reject) => {
    GetRequest(urls.GetPartyBookingInfo, obj)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getLrStatusV2 = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    GetRequest(urls.cargoLrStatus, data)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
